export const ToastStyles = {
	components: {
		Toast: {
			defaultProps: {
				position: 'bottom-left',
			},
		},
	},
};
